<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <sc-clickable :href="ctaHref" :target="ctaTarget" class="tile">
      <CommunityCard>
        <template #image>
          <media-display
            :sc-image-field="imageField"
            :image-desktop-source="imageSrc"
            :round="true"
          />
        </template>
        <template #imageCta>
          <sh-button
            v-if="!isEditMode && ctaHref"
            :[btnLinkKey]="ctaHref"
            :color="btnColor"
            :target="ctaTarget"
            :aria-label="ctaHiddenText || ctaText"
          >
            {{ ctaText }}
          </sh-button>
        </template>
        <template #title>
          <sc-text v-if="isEditMode || title" :field="titleField" />
        </template>
        <template #firstTag>
          <sc-text v-if="isEditMode || firstTag" class="tag" :field="firstTagField" />
        </template>
        <template #secondTag>
          <sc-text v-if="isEditMode || secondTag" class="tag" :field="secondTagField" />
        </template>
        <template #cta>
          <sh-button
            v-if="!isEditMode && ctaHref"
            size="small"
            :[btnLinkKey]="ctaHref"
            :color="btnColor"
            :target="ctaTarget"
            :aria-label="ctaHiddenText || ctaText"
          >
            {{ ctaText }}
          </sh-button>
        </template>
        <sc-link v-if="isEditMode" class="sc-link" :field="ctaField || {}" />
      </CommunityCard>
    </sc-clickable>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Image, Link, Text } from '@sitecore-jss/sitecore-jss-vue'
import { CommunityCard } from '@sohohouse/design-system'

import mapFields from '~/helpers/map-fields'
import getButtonColor from '~/helpers/get-button-color'
import { getButtonType } from '~/helpers/get-button-type'
import MediaDisplay from '~/components/sitecore/media-display'

import ScRender from '../sc-render'
import ScClickable from '../sc-clickable'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CommunityTile',

  components: {
    ScImage: Image,
    ScLink: Link,
    ScText: Text,
    ScRender,
    ScClickable,
    MediaDisplay,
    CommunityCard
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapFields({
      ctaField: 'cta',
      ctaHref: 'cta.value.href',
      ctaText: 'cta.value.text',
      ctaTarget: 'cta.value.target',
      ctaHiddenText: 'cta.value.data-hidden-text',
      ctaColor: 'ctaColor.value',
      firstTagField: 'tag1',
      firstTag: 'tag1.value',
      secondTagField: 'tag2',
      secondTag: 'tag2.value',
      imageField: 'profile.fields.image',
      imageSrc: 'profile.fields.image.value.src',
      titleField: 'profile.fields.title',
      title: 'profile.fields.title.value'
    }),
    isClickable () {
      return !this.isEditMode && this.ctaHref
    },
    btnLinkKey () {
      if (this.isClickable) return ''

      return getButtonType(this.ctaHref)
    },
    btnColor () {
      return getButtonColor(this.ctaColor)
    }
  }
}
</script>

<style lang="scss" scoped>
.tile {
  text-decoration: none;
}
</style>
